export default "__VITE_ASSET__f3a3fa95__"